export const compareStrings = (a, b) => {
  if (a && b) {
    // if both exist compare
    return a.localeCompare(b);
  } else if (a && !b) {
    return -1;
  } else if (!a && b) {
    return 1;
  } else if (!a && !b) {
    return 0;
  }
};

export const compareNumbers = (a, b) => a - b;
